<template>
  <div class="escrowTransfersDashboard js-tabBox escrowTransfersDashboard--admin">
    <div class="escrowTransfersDashboard__header">
      <div class="escrowTransfersDashboard__title">Stripe</div>
      <div class="escrowTransfersDashboard__nav">
        <div class="escrowTransfersDashboard__nav-container">
          <div data-id="escrow" class="escrowTransfersDashboard__nav-item js-tabNavItem" @click="tabActivate">
            <span class="text">Transfered to escrow</span>
          </div>
          <div data-id="platform" class="escrowTransfersDashboard__nav-item js-tabNavItem" @click="tabActivate">
            <span class="text">Transfered to platform</span>
          </div>
          <div data-id="seller-operator" class="escrowTransfersDashboard__nav-item js-tabNavItem" @click="tabActivate">
            <span class="text">Transfered to seller and operator</span>
          </div>
        </div>
      </div>
    </div>
    <div class="escrowTransfersDashboard__content">
      <div class="escrowTransfersDashboard__content-item js-tabContentItem">
        <div class="escrowTransfersDashboard__table">
          <div class="escrowTransfersDashboard__table-header">
            <div class="escrowTransfersDashboard__table-cell">№</div>
            <div class="escrowTransfersDashboard__table-cell">Seller</div>
            <div class="escrowTransfersDashboard__table-cell">Operator</div>
            <div class="escrowTransfersDashboard__table-cell">Type</div>
            <div class="escrowTransfersDashboard__table-cell">Departure</div>
            <div class="escrowTransfersDashboard__table-cell">Arrival</div>
            <div class="escrowTransfersDashboard__table-cell">Date</div>
            <div class="escrowTransfersDashboard__table-cell">Hours</div>
            <div class="escrowTransfersDashboard__table-cell">Price</div>
            <div class="escrowTransfersDashboard__table-cell">Price with fee</div>
          </div>
          <div class="escrowTransfersDashboard__table-body js-customScroll">
            <vue-scroll :ops="ops">
              <div
                v-for="(item, index) of escrowList"
                :key="index"
                class="escrowTransfersDashboard__table-row js-acc-item js-acc-hover-item"
                @mouseenter="controlShow"
                @mouseleave="controlHide"
              >
                <div class="escrowTransfersDashboard__table-row-header js-acc-title">
                  <div class="escrowTransfersDashboard__table-cell">
                    <div class="escrowTransfersDashboard__table-index">{{escrowList.length - index}}</div>
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    <a
                    @click="(e) => openAdditionalDetails(e, item.offer.seller)"
                    class="escrowTransfersDashboard__table-name">{{item.offer.seller.firstName + ' ' + item.offer.seller.lastName}}</a>
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    <a
                    @click="(e) => openAdditionalDetails(e, item.offer.operator)"
                    class="escrowTransfersDashboard__table-name">{{item.offer.operator ? item.offer.operator.companyName : ''}}</a>
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">{{item.offer.offerType.name}}</div>
                  <div class="escrowTransfersDashboard__table-cell">
                    {{item.offer.departure ? item.offer.departure.airport_Id : ''}}
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    {{item.offer.arrival ? item.offer.arrival.airport_Id : ''}}
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    <span>{{getDisplayDate(item.offer.departureDate)}}</span>
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    {{item.offer.NumberOfHours == 0 ? '' : item.offer.NumberOfHours}}
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    {{item.offer.offerPrice}}
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    {{item.amount}}
                  </div>
                </div>
                <div class="escrowTransfersDashboard__table-row-control js-acc-hover-content">
                  <div class="escrowTransfersDashboard__table-row-control-inner ">
                    <p class="escrowTransfersDashboard__table-link" @click="(e) => transferMoneyToPlatformClick(e, item)">
                      <span class="icon" />
                      <span class="text">Transfer to platform</span>
                    </p>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
      <div class="escrowTransfersDashboard__content-item js-tabContentItem">
        <div class="escrowTransfersDashboard__table">
          <div class="escrowTransfersDashboard__table-header">
            <div class="escrowTransfersDashboard__table-cell">№</div>
            <div class="escrowTransfersDashboard__table-cell">Seller</div>
            <div class="escrowTransfersDashboard__table-cell">Operator</div>
            <div class="escrowTransfersDashboard__table-cell">Type</div>
            <div class="escrowTransfersDashboard__table-cell">Departure</div>
            <div class="escrowTransfersDashboard__table-cell">Arrival</div>
            <div class="escrowTransfersDashboard__table-cell">Date</div>
            <div class="escrowTransfersDashboard__table-cell">Hours</div>
            <div class="escrowTransfersDashboard__table-cell">Price</div>
            <div class="escrowTransfersDashboard__table-cell">Price with fee</div>
          </div>
          <div class="escrowTransfersDashboard__table-body js-customScroll">
            <vue-scroll :ops="ops">
              <div
                v-for="(item, index) of platformList"
                :key="index"
                class="escrowTransfersDashboard__table-row js-acc-item js-acc-hover-item"
                @mouseenter="controlShow"
                @mouseleave="controlHide"
              >
                <div class="escrowTransfersDashboard__table-row-header js-acc-title">
                  <div class="escrowTransfersDashboard__table-cell">
                    <div class="escrowTransfersDashboard__table-index">{{platformList.length - index}}</div>
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    <a
                    @click="(e) => openAdditionalDetails(e, item.offer.seller)"
                    class="escrowTransfersDashboard__table-name">{{item.offer.seller.firstName + ' ' + item.offer.seller.lastName}}</a>
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    <a
                    @click="(e) => openAdditionalDetails(e, item.offer.operator)"
                    class="escrowTransfersDashboard__table-name">{{item.offer.operator ? item.offer.operator.companyName : ''}}</a>
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">{{item.offer.offerType.name}}</div>
                  <div class="escrowTransfersDashboard__table-cell">
                    {{item.offer.departure ? item.offer.departure.airport_Id : ''}}
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    {{item.offer.arrival ? item.offer.arrival.airport_Id : ''}}
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    <span>{{getDisplayDate(item.offer.departureDate)}}</span>
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    {{item.offer.NumberOfHours == 0 ? '' : item.offer.NumberOfHours}}
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    {{item.offer.offerPrice}}
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    {{item.amount}}
                  </div>
                </div>
                <div class="escrowTransfersDashboard__table-row-control js-acc-hover-content">
                  <div class="escrowTransfersDashboard__table-row-control-inner ">
                    <p class="escrowTransfersDashboard__table-link" @click="(e) => transferMoneyToSellerAndOperatorClick(e, item)">
                      <span class="icon" />
                      <span class="text">Transfer to Seller and Operator</span>
                    </p>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
      <div class="escrowTransfersDashboard__content-item js-tabContentItem">
        <div class="escrowTransfersDashboard__table">
          <div class="escrowTransfersDashboard__table-header">
            <div class="escrowTransfersDashboard__table-cell">№</div>
            <div class="escrowTransfersDashboard__table-cell">Seller</div>
            <div class="escrowTransfersDashboard__table-cell">Operator</div>
            <div class="escrowTransfersDashboard__table-cell">Type</div>
            <div class="escrowTransfersDashboard__table-cell">Departure</div>
            <div class="escrowTransfersDashboard__table-cell">Arrival</div>
            <div class="escrowTransfersDashboard__table-cell">Date</div>
            <div class="escrowTransfersDashboard__table-cell">Hours</div>
            <div class="escrowTransfersDashboard__table-cell">Price</div>
            <div class="escrowTransfersDashboard__table-cell">Price with fee</div>
          </div>
          <div class="escrowTransfersDashboard__table-body js-customScroll">
            <vue-scroll :ops="ops">
              <div
                v-for="(item, index) of sellerAndOperatorList"
                :key="index"
                class="escrowTransfersDashboard__table-row js-acc-item js-acc-hover-item"
              >
                <div class="escrowTransfersDashboard__table-row-header js-acc-title">
                  <div class="escrowTransfersDashboard__table-cell">
                    <div class="escrowTransfersDashboard__table-index">{{sellerAndOperatorList.length - index}}</div>
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    <a
                    @click="(e) => openAdditionalDetails(e, item.offer.seller)"
                    class="escrowTransfersDashboard__table-name">{{item.offer.seller.firstName + ' ' + item.offer.seller.lastName}}</a>
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    <a
                    @click="(e) => openAdditionalDetails(e, item.offer.operator)"
                    class="escrowTransfersDashboard__table-name">{{item.offer.operator ? item.offer.operator.companyName : ''}}</a>
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">{{item.offer.offerType.name}}</div>
                  <div class="escrowTransfersDashboard__table-cell">
                    {{item.offer.departure ? item.offer.departure.airport_Id : ''}}
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    {{item.offer.arrival ? item.offer.arrival.airport_Id : ''}}
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    <span>{{getDisplayDate(item.offer.departureDate)}}</span>
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    {{item.offer.NumberOfHours == 0 ? '' : item.offer.NumberOfHours}}
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    {{item.offer.offerPrice}}
                  </div>
                  <div class="escrowTransfersDashboard__table-cell">
                    {{item.amount}}
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
    </div>
    <FlyerDetailsPopup />
    <QuestionPopup
      :name="'QuestionPopupTransferToPlatform'"
      :title="'The money will be transferred from escrow to the pltform.'"
      :text="'Are you sure?'"
      @remove="transferMoneyToPlatform"
    />
    <QuestionPopup
      :name="'QuestionPopupTransferToSellerAndOperator'"
      :title="'The money will be transferred to the seller and the operator.'"
      :text="'Are you sure?'"
      @remove="transferMoneyToSellerAndOperator"
    />
    <InfoPopup/>
  </div>
</template>

<script>
  // import { reportsAPI } from '@/api/reports'
  import { Tabs } from '@/js/plugins/tabs'
  import FlyerDetailsPopup from '@/components/common/modals/FlyerDetailsPopup'
  import QuestionPopup from '@/components/common/modals/QuestionPopup'
  import InfoPopup from '@/components/common/modals/InfoPopup.vue';
  import './EscrowTransfers.styl'
  import moment from 'moment'

  export default {
    name: 'exchangeMembershipApps',
    data: () => ({
      tabs: new Tabs('.js-tabNavItem', '.js-tabContentItem'),
      ops: {
        rail: {
          size: '3px',
        },
        bar: {
          size: '3px',
          background: 'rgba(0,0,0,0.1)',
        },
      },
      tabSelected: 'escrow',
      currentItem: null,
    }),
    computed: {
      escrowList () {
        return this.$store.state.offerTransfers.escrowList
      },
      platformList () {
        return this.$store.state.offerTransfers.platformList
      },
      sellerAndOperatorList () {
        return this.$store.state.offerTransfers.sellerAndOperatorList
      },
    },
    async mounted () {
      this.tabs.addActiveForMouted()
      await this.$store.dispatch('getTransfersList', 0);
    },
    methods: {
      controlShow (event) {
        const item = event.currentTarget.closest('.escrowTransfersDashboard__table-row').querySelector('.js-acc-hover-content')
        this.$root.animations.slideDown(item)
        item.classList.add('show')
      },
      controlHide (event) {
        const item = event.currentTarget.closest('.escrowTransfersDashboard__table-row').querySelector('.js-acc-hover-content')
        item.classList.remove('show')
        this.$root.animations.slideUp(item)
      },
      openAdditionalDetails (e, account) {
        e.stopPropagation()
        this.$modal.show('FlyerDetailsPopup', {additionalInfo: account})
      },
      moment,
      // async exportToExcel () {
      //   try {
      //     const mode = this.historical ? 'historical' : 'current'
      //     const { data } = await reportsAPI.escrowTransfers(this.tabSelected, mode)
      //     const downloadLink = document.createElement('a');
      //     const blob = new Blob(['\ufeff', data]);
      //     const url = window.URL.createObjectURL(blob);
      //     downloadLink.href = url;
      //     downloadLink.download = 'escrowTransfers_report_' + new Date().toLocaleDateString().replaceAll('/', '-') + '.csv';
      //     document.body.appendChild(downloadLink);
      //     downloadLink.click();
      //     document.body.removeChild(downloadLink);
      //   } catch (e) {
      //     console.log(e)
      //   }
      // },
      getDisplayDate (dateString) {
      return dateString === null
        ? ''
        : `${new Date(dateString).toLocaleDateString('en-US')}`;
      },
      transferMoneyToPlatformClick (e, item) {
        e.stopPropagation();
        this.currentItem = item;
        this.$modal.show('QuestionPopupTransferToPlatform');
      },
      transferMoneyToSellerAndOperatorClick (e, item) {
        e.stopPropagation();
        this.currentItem = item;
        this.$modal.show('QuestionPopupTransferToSellerAndOperator');
      },
      async transferMoneyToPlatform () {
        const res = await this.$store.dispatch('transferMoneFromEscrowToPlatform', this.currentItem.transferId);
        console.log(res)
          if (!res.isSuccessfull) {
            this.$modal.show('InfoPopup', {
              title: 'Error',
              text: res.message,
            });
          } else {
            this.$router.go();
          }
          this.currentItem = null;
          this.$modal.hide('QuestionPopupTransferToPlatform')
      },
      async transferMoneyToSellerAndOperator () {
        const res = await this.$store.dispatch('transferMoneToSellerAndOperator', this.currentItem.transferId);
        console.log(res)
          if (!res.isSuccessfull) {
            this.$modal.show('InfoPopup', {
              title: 'Error',
              text: res.message,
            });
          } else {
            this.$router.go();
          }
          this.currentItem = null;
          this.$modal.hide('QuestionPopupTransferToSellerAndOperator')
      },
      tabActivate (event) {
        this.tabSelected = event.currentTarget.getAttribute('data-id')
        if (this.tabSelected === 'escrow') {
          this.$store.dispatch('getTransfersList', 0);
        } else if (this.tabSelected === 'platform') {
          this.$store.dispatch('getTransfersList', 1);
        } else if (this.tabSelected === 'seller-operator') {
          this.$store.dispatch('getTransfersList', 2);
        }
        this.tabs.addActiveForClick(event.currentTarget)
      },
    },
    components: {
      FlyerDetailsPopup,
      QuestionPopup,
      InfoPopup,
    },
  }
</script>